<template>
    <v-card class="mx-auto">
        <v-card-title>Course in the Ward</v-card-title>
        <v-card-text>
            <v-form ref="form" lazy-validation>
                <v-row>
                    <v-col cols="12" md="2" sm="12">
                        <v-menu
                                v-model="dateAction"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="computedDateFormatted"
                                        label="Date action"
                                        placeholder="YYYY-MM-DD"
                                        hint="YYYY-MM-DD Format"
                                        persistent-hint
                                        outlined
                                        readonly
                                        clearable
                                        v-on="on"
                                        :rules="[v => !!v || 'Date action is required']"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="course_ward.date_action" no-title @input="dateAction = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="9" sm="12">
                        <v-textarea
                                outlined
                                rows="1"
                                auto-grow
                                v-model="course_ward.doctor_action"
                                :rules="[v => !!v || 'Doctor Action is required']"
                                placeholder="Doctor Action"
                                label="Doctor Action"
                                required
                        />
                    </v-col>
                    <v-col cols="12" md="1" sm="12">
                        <v-btn @click="addRow" color="success" class="ma-2 float-md-right">
              <v-icon>mdi-plus</v-icon>
              Add
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-btn @click="expandWoundForm = !expandWoundForm" color="warning" class="ma-2">
                          <v-icon left>mdi-bandage</v-icon>
                          Wound Assessment
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Wound Assessment Form -->
                <v-expand-transition>
                    <div v-show="expandWoundForm">
                        <v-divider class="my-4"></v-divider>
                        <v-card flat outlined class="pa-4">
                            <v-card-title class="text-subtitle-1">Wound Assessment</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-text-field
                                            v-model="wound.wound_location"
                                            label="Location"
                                            placeholder="e.g., Left Heel"
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-text-field
                                            v-model="wound.wound_size"
                                            label="Size (cm)"
                                            placeholder="e.g., 3"
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">DEPTH</v-card-subtitle>
                                        <v-checkbox v-model="wound.depth" value="SC" label="SC" :disabled="wound.depth.length > 0 && !wound.depth.includes('SC')"></v-checkbox>
                                        <v-checkbox v-model="wound.depth" value="Muscle" label="Muscle" :disabled="wound.depth.length > 0 && !wound.depth.includes('Muscle')"></v-checkbox>
                                        <v-checkbox v-model="wound.depth" value="Fascia" label="Fascia" :disabled="wound.depth.length > 0 && !wound.depth.includes('Fascia')"></v-checkbox>
                                        <v-checkbox v-model="wound.depth" value="Bone" label="Bone" :disabled="wound.depth.length > 0 && !wound.depth.includes('Bone')"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">WOUND BED</v-card-subtitle>
                                        <v-checkbox v-model="wound.wound_bed" value="Granulation" label="Granulation" :disabled="wound.wound_bed.length > 0 && !wound.wound_bed.includes('Granulation')"></v-checkbox>
                                        <v-checkbox v-model="wound.wound_bed" value="Slough" label="Slough" :disabled="wound.wound_bed.length > 0 && !wound.wound_bed.includes('Slough')"></v-checkbox>
                                        <v-checkbox v-model="wound.wound_bed" value="Necrotic" label="Necrotic" :disabled="wound.wound_bed.length > 0 && !wound.wound_bed.includes('Necrotic')"></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">EXUDATE</v-card-subtitle>
                                        <v-checkbox v-model="wound.exudate" value="None" label="None" :disabled="wound.exudate.length > 0 && !wound.exudate.includes('None')"></v-checkbox>
                                        <v-checkbox v-model="wound.exudate" value="Scant" label="Scant" :disabled="wound.exudate.length > 0 && !wound.exudate.includes('Scant')"></v-checkbox>
                                        <v-checkbox v-model="wound.exudate" value="Mod" label="Mod" :disabled="wound.exudate.length > 0 && !wound.exudate.includes('Mod')"></v-checkbox>
                                        <v-checkbox v-model="wound.exudate" value="Heavy" label="Heavy" :disabled="wound.exudate.length > 0 && !wound.exudate.includes('Heavy')"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">ODOR</v-card-subtitle>
                                        <v-checkbox v-model="wound.odor" value="None" label="None" :disabled="wound.odor.length > 0 && !wound.odor.includes('None')"></v-checkbox>
                                        <v-checkbox v-model="wound.odor" value="Foul" label="Foul" :disabled="wound.odor.length > 0 && !wound.odor.includes('Foul')"></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">PERI-WOUND/INFECTION</v-card-subtitle>
                                        <v-checkbox v-model="wound.peri_wound_infection" value="Intact" label="Intact" :disabled="wound.peri_wound_infection.length > 0 && !wound.peri_wound_infection.includes('Intact')"></v-checkbox>
                                        <v-checkbox v-model="wound.peri_wound_infection" value="Red" label="Red" :disabled="wound.peri_wound_infection.length > 0 && !wound.peri_wound_infection.includes('Red')"></v-checkbox>
                                        <v-checkbox v-model="wound.peri_wound_infection" value="Macerated" label="Macerated" :disabled="wound.peri_wound_infection.length > 0 && !wound.peri_wound_infection.includes('Macerated')"></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                        <v-card-subtitle class="text-body2 font-weight-bold">INFECTION SIGNS</v-card-subtitle>
                                        <v-checkbox v-model="wound.infection_signs" value="None" label="None" :disabled="wound.infection_signs.length > 0 && !wound.infection_signs.includes('None')"></v-checkbox>
                                        <v-checkbox v-model="wound.infection_signs" value="Present" label="Present" :disabled="wound.infection_signs.length > 0 && !wound.infection_signs.includes('Present')"></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row>
                                <v-col cols="12" md="6" sm="12">
                                    <v-card-subtitle class="text-body2 font-weight-bold">UNDERMINING/TUNNELLING</v-card-subtitle>

                                    <v-checkbox
                                        v-model="wound.undermining_tunnelling"
                                        value="None"
                                        label="None"
                                        :disabled="wound.undermining_tunnelling.length > 0 && !wound.undermining_tunnelling.includes('None')"
                                    ></v-checkbox>

                                    <v-text-field
                                        v-model="wound.undermining_tunnelling_cm"
                                        label="Size (cm)"
                                        placeholder="cm"
                                        outlined
                                        class="mt-2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6" sm="12">
                                    <v-card-subtitle class="text-body2 font-weight-bold">PAIN</v-card-subtitle>

                                    <v-checkbox
                                        v-model="wound.pain"
                                        value="None"
                                        label="None"
                                        :disabled="wound.pain.length > 0 && !wound.pain.includes('None')"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="wound.pain"
                                        value="Present"
                                        label="Present"
                                        :disabled="wound.pain.length > 0 && !wound.pain.includes('Present')"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="6" sm="12">
                                    <v-card-subtitle class="text-body2 font-weight-bold">BLEEDING</v-card-subtitle>

                                    <v-checkbox
                                        v-model="wound.bleeding"
                                        value="Scant"
                                        label="Scant"
                                        :disabled="wound.bleeding.length > 0 && !wound.bleeding.includes('Scant')"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="wound.bleeding"
                                        value="Poor"
                                        label="Poor"
                                        :disabled="wound.bleeding.length > 0 && !wound.bleeding.includes('Poor')"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="wound.bleeding"
                                        value="Good"
                                        label="Good"
                                        :disabled="wound.bleeding.length > 0 && !wound.bleeding.includes('Good')"
                                    ></v-checkbox>
                                </v-col>

                                <v-col cols="12" md="6" sm="12">
                                    <v-card-subtitle class="text-body2 font-weight-bold">VASCULAR</v-card-subtitle>

                                    <v-checkbox
                                        v-model="wound.vascular"
                                        value="Normal"
                                        label="Normal"
                                        :disabled="wound.vascular.length > 0 && !wound.vascular.includes('Normal')"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="wound.vascular"
                                        value="Impaired"
                                        label="Impaired"
                                        :disabled="wound.vascular.length > 0 && !wound.vascular.includes('Impaired')"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="6" sm="12">
                                    <v-card-subtitle class="text-body2 font-weight-bold">EDGES</v-card-subtitle>

                                    <v-checkbox
                                        v-model="wound.edges"
                                        value="Defined"
                                        label="Defined"
                                        :disabled="wound.edges.length > 0 && !wound.edges.includes('Defined')"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="wound.edges"
                                        value="Irregular"
                                        label="Irregular"
                                        :disabled="wound.edges.length > 0 && !wound.edges.includes('Irregular')"
                                    ></v-checkbox>
                                </v-col>

                                <v-col cols="12" md="6" sm="12">
                                    <v-textarea
                                        v-model="wound.notes"
                                        label="Notes (optional)"
                                        placeholder="Additional remarks..."
                                        outlined
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                            </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-btn @click="applyWoundAssessment" color="primary" class="mr-2">
                                          <v-icon left>mdi-check</v-icon>
                                          Apply
                                        </v-btn>
                                        <v-btn @click="clearWoundForm" color="secondary">
                                          <v-icon left>mdi-refresh</v-icon>
                                          Clear
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-expand-transition>
                <v-row>
                    <v-col>
            <v-simple-table>
                            <thead>
                            <tr>
                                <th class="text-left">Date Action</th>
                                <th class="text-left">Doctor Action</th>
                                <th class="text-left">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in formData.course_ward" :key="index">
                                <td>{{ item.date_action }}</td>
                                <td>{{ item.doctor_action }}</td>
                                <td>
                  <v-btn @click="remove(index)"  x-small fab dark color="red">
                    <v-icon>mdi-window-close</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-form>


        </v-card-text>
        <v-card-actions>
      <v-spacer></v-spacer>

            <v-btn
                    :disabled="currentTab === 0"
                    @click="backTab"
                    color="info"
                    class="mr-4">
                BACK
            </v-btn>
            <v-btn
                    :disabled="!formData.course_ward.length"
                    @click="validate"
                    color="success"
                    class="mr-4">
                NEXT
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "CourseWard",

        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                menu: false,
                valid: false,
                dateAction: false,
                expandWoundForm: false,
                course_ward: {},
                wound: {
                    wound_location: '',
                    wound_size: '',
                    depth: [],
                    wound_bed: [],
                    exudate: [],
                    odor: [],
                    peri_wound_infection: [],
                    infection_signs: [],
                    undermining_tunnelling: [],
                    undermining_tunnelling_cm: '',
                    pain: [],
                    bleeding: [],
                    vascular: [],
                    edges: [],
                    notes: ''
                }
            }
        },

        computed: {
            computedDateFormatted: {
                get() {
                    return this.parseDate(this.course_ward.date_action);
                },
                set(value) {
                    this.course_ward.date_action = value;
                },
            },
        },

        watch: {
            date (val) {
                this.dateFormatted = this.formatDate(this.course_ward.date_action)
            },
        },

        methods: {
            validate() {
                if (this.formData.course_ward.length !== 0) {
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },

            addRow() {
                const course_ward = this.formData.course_ward;
                if (this.$refs.form.validate()) {
                    course_ward.push({
                        date_action: this.course_ward.date_action,
                        doctor_action: this.course_ward.doctor_action,
                    });
                    this.reset();
                    course_ward.sort(function(a, b) {
                        let dateA = new Date(a.date_action), dateB = new Date(b.date_action);
                        return dateA - dateB;
                    });
                }
            },

            remove(index) {
                this.formData.course_ward.splice(index, 1);
            },

            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            buildWoundSummary() {
                let summary = '';
                
                if (this.wound.wound_location) {
                    summary += `Wound: Located at ${this.wound.wound_location}`;
                    if (this.wound.wound_size) {
                        summary += `, ${this.wound.wound_size}cm`;
                    }
                }

                const parts = [];
                
                if (this.wound.depth && this.wound.depth.length > 0) {
                    parts.push(`Depth: ${this.wound.depth.join(', ')}`);
                }
                if (this.wound.wound_bed && this.wound.wound_bed.length > 0) {
                    parts.push(`Wound Bed: ${this.wound.wound_bed.join(', ')}`);
                }
                if (this.wound.exudate && this.wound.exudate.length > 0) {
                    parts.push(`Exudate: ${this.wound.exudate.join(', ')}`);
                }
                if (this.wound.odor && this.wound.odor.length > 0) {
                    parts.push(`Odor: ${this.wound.odor.join(', ')}`);
                }
                if (this.wound.peri_wound_infection && this.wound.peri_wound_infection.length > 0) {
                    parts.push(`Peri-Wound/Infection: ${this.wound.peri_wound_infection.join(', ')}`);
                }
                if (this.wound.infection_signs && this.wound.infection_signs.length > 0) {
                    parts.push(`Infection Signs: ${this.wound.infection_signs.join(', ')}`);
                }
                if (this.wound.undermining_tunnelling && this.wound.undermining_tunnelling.length > 0) {
                    if (this.wound.undermining_tunnelling[0] === 'None') {
                        parts.push('Undermining/Tunnelling: None');
                    } else if (this.wound.undermining_tunnelling_cm) {
                        parts.push(`Undermining/Tunnelling: ${this.wound.undermining_tunnelling_cm}cm`);
                    }
                }
                if (this.wound.pain && this.wound.pain.length > 0) {
                    parts.push(`Pain: ${this.wound.pain.join(', ')}`);
                }
                if (this.wound.bleeding && this.wound.bleeding.length > 0) {
                    parts.push(`Bleeding: ${this.wound.bleeding.join(', ')}`);
                }
                if (this.wound.vascular && this.wound.vascular.length > 0) {
                    parts.push(`Vascular: ${this.wound.vascular.join(', ')}`);
                }
                if (this.wound.edges && this.wound.edges.length > 0) {
                    parts.push(`Edges: ${this.wound.edges.join(', ')}`);
                }
                if (this.wound.notes) {
                    parts.push(`Notes: ${this.wound.notes}`);
                }

                if (parts.length > 0) {
                    if (summary) {
                        summary += ', ' + parts.join(', ');
                    } else {
                        summary = parts.join(', ');
                    }
                }

                return summary;
            },

            applyWoundAssessment() {
                const woundSummary = this.buildWoundSummary();
                if (woundSummary) {
                    this.course_ward.doctor_action += (this.course_ward.doctor_action ? ' - ' : '') + woundSummary;
                    this.clearWoundForm();
                    this.expandWoundForm = false;
                } else {
                    alert('Please fill in at least one wound assessment field');
                }
            },

            clearWoundForm() {
                this.wound = {
                    wound_location: '',
                    wound_size: '',
                    depth: [],
                    wound_bed: [],
                    exudate: [],
                    odor: [],
                    peri_wound_infection: [],
                    infection_signs: [],
                    undermining_tunnelling: [],
                    undermining_tunnelling_cm: '',
                    pain: [],
                    bleeding: [],
                    vascular: [],
                    edges: [],
                    notes: ''
                };
            },
        },
    }
</script>

<style scoped>

</style>